export default __webpack_public_path__ + "static/media/tweet1.c0ce7e66.png";